// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_IAB_CATEGORY } from './select-iab-category.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_IAB_CATEGORY);

export const selectIabCategoryListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectIabCategoryListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectIabCategoryListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);
